/* Progressive enhancement only: all product links remain available without JS. */
(() => {
  function mount(root) {
    if (root.dataset.brReady) return;
    root.dataset.brReady = 'true';
    const cards = [...root.querySelectorAll('[data-br-product]')];
    const controls = root.querySelector('[data-br-filters]');
    const buttons = [...root.querySelectorAll('[data-br-filter]')];
    const type = root.querySelector('[data-br-type]');
    const result = root.querySelector('[data-br-results]');
    const empty = root.querySelector('[data-br-empty]');
    if (!controls || !type || !result || !empty) return;
    let family = 'all';
    const update = () => {
      let count = 0;
      cards.forEach(card => {
        const show = (family === 'all' || card.dataset.brFamily === family) && (type.value === 'all' || card.dataset.brTypes.split(' ').includes(type.value));
        card.hidden = !show;
        if (show) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brFilter === family)));
      result.textContent = `${count} ${count === 1 ? 'heater model' : 'heater models'}${family === 'all' ? '' : ` in ${family.charAt(0).toUpperCase() + family.slice(1)}`}`;
      empty.hidden = count !== 0;
    };
    buttons.forEach(button => button.addEventListener('click', () => { family = button.dataset.brFilter; update(); }));
    type.addEventListener('change', update);
    root.querySelectorAll('[data-br-preset]').forEach(link => link.addEventListener('click', () => { family = link.dataset.brPreset; type.value = 'all'; update(); }));
    root.querySelectorAll('[data-br-setup]').forEach(link => link.addEventListener('click', () => { family = 'all'; type.value = link.dataset.brSetup; update(); }));
    root.querySelector('[data-br-reset]')?.addEventListener('click', () => { family = 'all'; type.value = 'all'; update(); buttons[0]?.focus(); });
    controls.hidden = false;
    update();
  }
  document.querySelectorAll('[data-ef-bromic]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ef-bromic]').forEach(mount));
})();
